module.exports = __webpack_public_path__ + "static/img/activity-1.96a3dea.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity-1.png
// module id = tqFR
// module chunks = 1